// removed by extract-text-webpack-plugin
module.exports = {"info":"dh-skogbrann-sverige-2018-info","info__title":"dh-skogbrann-sverige-2018-info__title","info__section":"dh-skogbrann-sverige-2018-info__section","info__icon":"dh-skogbrann-sverige-2018-info__icon","info__icon--developed":"dh-skogbrann-sverige-2018-info__icon--developed","info__icon--forest":"dh-skogbrann-sverige-2018-info__icon--forest","info__icon--football":"dh-skogbrann-sverige-2018-info__icon--football","info__icon--fire":"dh-skogbrann-sverige-2018-info__icon--fire","info__text":"dh-skogbrann-sverige-2018-info__text"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/components/Info/index.css
// module id = 23
// module chunks = 0